<div class="rps-prestadores-registrados-filtro relative">
  <p-button
    icon="pi pi-filter"
    [styleClass]="'p-button-primary p-button-outlined ' + (count ? 'filter-active' : '')"
    [label]="label"
    (click)="onShow($event)"
  ></p-button>
  @if (count > 0) {
    <i
      class="pi pi-times-circle filter-clear-icon cursor-pointer icon-clear w-1rem h-1rem"
      pTooltip="Limpar todos os filtros"
      tooltipPosition="bottom"
      (click)="onClear()"
    ></i>
  }

  <p-popover #filterPanel>
    <ng-template pTemplate="content">
      <div class="filter-panel">
        <div class="filter-columns-container">
          <div class="filter-column">
            <div class="field filter-item mb-2">
              <label>Classificação</label>
              <p-select
                size="small"
                [options]="classificacaoOptions"
                [(ngModel)]="local.idClassificacao"
                optionLabel="label"
                optionValue="value"
                dropdownIcon="pi pi-angle-down"
                placeholder="Todas"
                [showClear]="true"
                styleClass="w-full"
                appendTo="body"
              ></p-select>
            </div>

            <div class="field filter-item mb-2">
              <label>Urgência/Emergência</label>
              <p-select
                size="small"
                [options]="urgenciaEmergenciaOptions"
                [(ngModel)]="local.snUrgenciaEmergencia"
                optionLabel="label"
                optionValue="value"
                dropdownIcon="pi pi-angle-down"
                placeholder="Todos"
                [showClear]="true"
                styleClass="w-full"
                appendTo="body"
              ></p-select>
            </div>

            <div class="field filter-item mb-2">
              <label>Relação com a operadora</label>
              <p-select
                size="small"
                [options]="relacaoOperadoraOptions"
                [(ngModel)]="local.tpRelacaoOperadora"
                optionLabel="label"
                optionValue="value"
                dropdownIcon="pi pi-angle-down"
                placeholder="Todas"
                [showClear]="true"
                styleClass="w-full"
                appendTo="body"
              ></p-select>
            </div>

            <div class="field filter-item mb-2">
              <label>Contratualização</label>
              <p-select
                size="small"
                [options]="contratualizacaoOptions"
                [(ngModel)]="local.tpContratualizacao"
                optionLabel="label"
                optionValue="value"
                dropdownIcon="pi pi-angle-down"
                placeholder="Todas"
                [showClear]="true"
                styleClass="w-full"
                appendTo="body"
              ></p-select>
            </div>
          </div>

          <div class="filter-column">
            <div class="field filter-item mb-2">
              <label for="rps-filtro-cnpj">CPF/CNPJ</label>
              <input
                pInputText
                pSize="small"
                id="rps-filtro-cnpj"
                class="w-full"
                autocomplete="off"
                [(ngModel)]="local.nrCpfCnpj"
                (keydown.enter)="onApply()"
              />
            </div>

            <div class="field filter-item mb-2">
              <label for="rps-filtro-cnes">CNES</label>
              <input
                pInputText
                pSize="small"
                id="rps-filtro-cnes"
                class="w-full"
                autocomplete="off"
                [(ngModel)]="local.nrCnes"
                (keydown.enter)="onApply()"
              />
            </div>

            <div class="field filter-item mb-2">
              <label for="rps-filtro-registro-plano">Registro do plano</label>
              <input
                pInputText
                pSize="small"
                id="rps-filtro-registro-plano"
                class="w-full"
                autocomplete="off"
                [(ngModel)]="local.nrRegistroPlano"
                (keydown.enter)="onApply()"
              />
            </div>
          </div>
        </div>

        <hr class="mt-2 mb-3" />

        <div class="w-full flex justify-content-end">
          <p-button styleClass="mr-2 p-button-sm" (click)="onApply()">Aplicar</p-button>
          <p-button styleClass="p-button-sm p-button-outlined" (click)="onClear()">Limpar</p-button>
        </div>
      </div>
    </ng-template>
  </p-popover>
</div>
